export const PageHead = ({ eyebrow, title, children, actions }) => (
  <div className="px-5 md:px-10 pt-8 pb-6 border-b border-[color:var(--line)] flex flex-col md:flex-row md:items-end justify-between gap-4 no-print">
    <div>
      <div className="eyebrow mb-2">{eyebrow}</div>
      <h1 className="font-display text-3xl md:text-4xl font-bold text-ink">{title}</h1>
      {children && <p className="text-sm text-slate-400 mt-2 max-w-2xl">{children}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const TabBar = ({ tabs, value, onChange }) => (
  <div className="flex gap-1 overflow-x-auto px-5 md:px-10 border-b border-[color:var(--line)] no-print">
    {tabs.map(([k, l]) => (
      <button key={k} onClick={() => onChange(k)} data-testid={`tab-${k}`}
        className={`px-4 py-3 text-sm whitespace-nowrap border-b-2 transition-colors ${value === k ? "border-[color:var(--gold)] text-gold" : "border-transparent text-slate-400 hover:text-ink"}`}>{l}</button>
    ))}
  </div>
);
